module.exports = __webpack_public_path__ + "images/tour/done.273a4990e2bcb6712353.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tour/done.svg
// module id = REwO
// module chunks = 12